module.exports = __webpack_public_path__ + "static/img/govIcon.b65863ce.svg";